import { createAsyncThunk } from '@reduxjs/toolkit';
import { languageToSeed } from '../i18n/accountLanguage';
import { clearPendingLanguageSeed } from './slices/authSlice';
import {
  applyGameSettingsLocal,
  fetchGameSettings,
  updateGameSettings,
} from './slices/gameSlice';
import { setLanguagePreview } from './slices/uiSlice';
import type { RootState } from './index';

/**
 * First game-settings load after sign-in. Applies the language rule from
 * `i18n/accountLanguage.ts`: a new account takes the language the visitor
 * chose before registering, an existing account keeps its own. Either way the
 * public-page preview is dropped once the account language is known.
 */
export const loadAccountSettings = createAsyncThunk(
  'game/loadAccountSettings',
  async (_, { dispatch, getState }) => {
    const pending = (getState() as RootState).auth.pendingLanguageSeed;
    if (pending) {
      dispatch(setLanguagePreview(pending));
    }
    const fetched = await dispatch(fetchGameSettings());
    if (!fetchGameSettings.fulfilled.match(fetched)) {
      return;
    }
    dispatch(clearPendingLanguageSeed());
    const seed = languageToSeed(pending, fetched.payload?.language);
    if (seed) {
      dispatch(applyGameSettingsLocal({ language: seed }));
      await dispatch(updateGameSettings({ language: seed }));
    }
    dispatch(setLanguagePreview(null));
  }
);
